import { FC } from 'react';
import { CodeBlockProps } from './CodeBlock.types';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { a11yDark } from 'react-syntax-highlighter/dist/esm/styles/prism';

export const CodeBlock: FC<CodeBlockProps> = ({
  children,
  language = 'typescript',
}) => {
  const codeString: string =
    typeof children === 'string' ? children : String(children);

  return (
    <SyntaxHighlighter
      language={language}
      style={a11yDark}
      customStyle={{
        fontSize: '14px',
        borderRadius: '8px',
      }}
      showLineNumbers={true}
    >
      {codeString}
    </SyntaxHighlighter>
  );
};
